module.exports = __webpack_public_path__ + "img/open7.393fad51.png";